export const PAGE_LIMIT = 25;
export const SEARCH_TYPES = {
  PATIENT: 'participant',
  ORDERING_PHYSICIAN: 'ordering_provider',
  CONNECTIONS: 'connections',
  BILLING: 'billing',
  RECORDINGS: 'recordings',
  TRIAGE: 'triage',
  ANALYSIS: 'analysis',
  QA: 'qa',
  COMPLETED: 'completed',
};
Object.freeze(SEARCH_TYPES);

export const VALID_SEARCH_TYPES = Object.values(SEARCH_TYPES);
export const tagTokenPrefix = 'mrn:';
/**
 * Extracts out the mrn if there is one. Otherwise return the original tag value
 * */
export function getMRNFromTag(tagValue) {
  const regEx = new RegExp(`(\\[${tagTokenPrefix})(.*)]$`);
  if (tagValue) {
    const indexToken = tagValue.search(regEx);
    if (indexToken !== -1) {
      return tagValue.substring(
        indexToken + tagTokenPrefix.length + 1,
        tagValue.length - 1,
      );
    }
  }
  return tagValue;
}



// WEBPACK FOOTER //
// ./src/state/services/searchApiUtils.js